export default "__VITE_PUBLIC_ASSET__583a54c6__"